/* eslint-disable */
export default {
  rateExceeded: '要求の上限を超えました。アプリは{ttl}秒後に再開します。',
} as const;

// @key: @#@"rateExceeded"@#@ @source: @#@"Request limit exceeded. App will resume in {ttl} seconds."@#@
